"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingListToJSON = exports.BookingListFromJSONTyped = exports.BookingListFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BookingListFromJSON(json) {
    return BookingListFromJSONTyped(json, false);
}
exports.BookingListFromJSON = BookingListFromJSON;
function BookingListFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'bookingList': !(0, runtime_1.exists)(json, 'bookingList') ? undefined : (json['bookingList'].map(_1.BookingListBookingListFromJSON)),
        'nextDataId': !(0, runtime_1.exists)(json, 'nextDataId') ? undefined : json['nextDataId'],
    };
}
exports.BookingListFromJSONTyped = BookingListFromJSONTyped;
function BookingListToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bookingList': value.bookingList === undefined ? undefined : (value.bookingList.map(_1.BookingListBookingListToJSON)),
        'nextDataId': value.nextDataId,
    };
}
exports.BookingListToJSON = BookingListToJSON;
//# sourceMappingURL=BookingList.js.map